export function onlyDefined(t) {
    return t.filter((i) => !!i);
}
